import { createLoadingReducer } from './utils';

export default createLoadingReducer('APTUS_SETTINGS');
